export default {
  colorPrimary: '#E6FC57',
  colorPrimaryDark: '#1D1C22',
  colorSecondary: '#FCF9F2',
  colorSecondaryDark: '#D1D6CE',
  colorTextPrimary: '#1D1C22',
  colorTextSecondary: '#FFFFFF',
};
